<div (click)="onFilterClick()" class="filter"
     [ngClass]="{selected: gamesFilter.isActiveFiltersSearch()}"
>
  <div class="filter__icon">
    <i class="icon-filter"></i>
  </div>
</div>
